import React from "react";

import { UniverseCardProps } from "./universeCard.model";
import { ImageCard } from "@companion-core/shared/app/Components/Cards/ImageCard";

import "@companion-core/web/src/Assets/Styles/scss/universeCard.scss";
import { getCloudinaryOptimizedUrl } from "@companion-core/shared/app/Utils/cloudinary";

export const UniverseCard = ({ universe, onClick }: UniverseCardProps) => {
  const image = universe.medias?.length > 0 ? universe.medias[0] : null;

  return (
    <button onClick={onClick} className="universe-card">
      <ImageCard
        testID={`universe-card--${universe.id}`}
        allInOne
        bottomContent
        withGradient
        className="universe-card__image-card"
        imageUrl={getCloudinaryOptimizedUrl(image?.url ?? "", {
          contentType: "card",
        })}
        imageAlt={image?.description_alt ?? ""}>
        <span
          data-testid={`universe-card__title--${universe.id}`}
          className="universe-card__title body-text-5">
          {universe.title}
        </span>
      </ImageCard>
    </button>
  );
};
